
<div>
    <app-bar :title="t('workout_executions_title')"></app-bar>

    <template v-if="touchedWorkoutExecution.exists()">
        <v-app-bar
            color="transparent"
            height="84"
            elevation="0"
            class="mb-n6 px-6"
        >
            <v-toolbar-title>{{ touchedWorkoutExecution.workout.name }}</v-toolbar-title>
            <v-btn
                @click="unset()"
                plain
                icon
                absolute
                right
                class="mr-n8"
            ><v-icon>mdi-close</v-icon></v-btn>
        </v-app-bar>

        <div class="px-10 pb-6 overflow-hidden">
            <workout-execution-view :execution="touchedWorkoutExecution"></workout-execution-view>
        </div>
    </template>

    <v-layout>
        <template v-if="! touchedWorkoutExecution.exists()">
            <workout-execution-collection
                @touched="touchWorkoutExecution"
            ></workout-execution-collection>
        </template>
    </v-layout>
</div>
